<template>
  <lf-card class="mb-8 max-w-screen-md" data-cy="scoreCardTab">
    <loader :isLoading="isSubmitting" />
    <form @submit.prevent="submit">
      <div class="space-y-5 pb-2 pt-8">
        <lf-switch
          name="data.can_manage_score_cards"
          v-model="initialValues.data.can_manage_score_cards"
        >
          <lf-h3>
            {{ $t("ORGANIZATION.ENABLE_SCORECARDS") }}
          </lf-h3>
          <span class="mt-2">
            {{ $t("ORGANIZATION.ENABLE_SCORECARDS_SUBTITLE") }}
          </span>
        </lf-switch>
      </div>
      <div
        class="mt-5 flex min-w-full items-center justify-end border-t py-6 pr-5"
      >
        <primary-button
          type="submit"
          :disabled="isSubmitting"
          data-cy="scoreCardTabSubmit"
        >
          {{ $t("ORGANIZATION.API_CONFIG.SAVE_CHANGES") }}
        </primary-button>
      </div>
    </form>
  </lf-card>
</template>

<script setup lang="ts">
import { reactive } from "vue";
import { useForm } from "vee-validate";
import { dispatchAction } from "@/helpers/vee-validate";
import { useClients } from "@/hooks/clients";

const { activeClient } = useClients();

const initialValues = reactive({
  data: {
    can_manage_score_cards: !!activeClient.value?.can_manage_score_cards
  }
});

const { handleSubmit, isSubmitting } = useForm({
  initialValues
});

const submit = handleSubmit(async (values, actions) => {
  await dispatchAction(values, actions, "clients/updateClient");
});
</script>
